import { render } from "./ObjectDetection.vue?vue&type=template&id=6bc6e2ce"
import script from "./ObjectDetection.vue?vue&type=script&lang=js"
export * from "./ObjectDetection.vue?vue&type=script&lang=js"

import "./ObjectDetection.vue?vue&type=style&index=0&id=6bc6e2ce&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__